import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import OpsSubnav from "../OpsSubnav";
import OverviewPage from "./OverviewPage";
import ProductsPage from "./ProductsPage";
import ProductForm from "./ProductForm";
import StockPage from "./StockPage";
import ReceiptsPage from "./ReceiptsPage";
import OrdersPage from "./OrdersPage";
import VendorsPage from "./VendorsPage";
import CompliancePage from "./CompliancePage";
import OnHandPage from "./OnHandPage";
import ProductLedgerPage from "./ProductLedgerPage";
import LedgerPage from "./LedgerPage";
import ChemicalFlagsPage from "./ChemicalFlagsPage";
import ChemicalUsagePage from "./ChemicalUsagePage";
import "../OpsNav.css";
import "./Inventory.css";

export default function InventoryRouter(){
  return (
    <div className="inventory-wrap">
      <OpsSubnav
        section="inventory"
        tabs={[
          { key: "overview", label: "Overview", to: "" },
          { key: "on-hand",  label: "On hand",  to: "on-hand" },
          { key: "ledger",   label: "Ledger",   to: "ledger" },
          { key: "flags",    label: "Application flags", to: "flags" },
          { key: "usage",    label: "Usage & order", to: "usage" },
          { key: "products", label: "Products", to: "products" },
          { key: "stock",    label: "Stock",    to: "stock" },
          { key: "receipts", label: "Receipts", to: "receipts" },
          { key: "orders",   label: "Orders",   to: "orders" },
          { key: "vendors",  label: "Vendors",  to: "vendors" },
          { key: "compliance", label: "Compliance", to: "compliance" },
        ]}
      />
      <Routes>
        <Route index element={<OverviewPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="products/new" element={<ProductForm />} />
        <Route path="products/:id/edit" element={<ProductForm />} />
        <Route path="stock" element={<StockPage />} />
        <Route path="on-hand" element={<OnHandPage />} />
        <Route path="ledger" element={<LedgerPage />} />
        <Route path="products/:id/ledger" element={<ProductLedgerPage />} />
        <Route path="flags" element={<ChemicalFlagsPage />} />
        <Route path="usage" element={<ChemicalUsagePage />} />
        <Route path="receipts" element={<ReceiptsPage />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="vendors" element={<VendorsPage />} />
        <Route path="compliance" element={<CompliancePage />} />
        <Route path="*" element={<Navigate to="." replace />} />
      </Routes>
    </div>
  );
}